import React, {Fragment} from 'react';
import parse, {attributesToProps, domToReact, HTMLReactParserOptions} from 'html-react-parser';

const parserOptions: HTMLReactParserOptions = {
    replace: (domNode) => {
        if (domNode.type === 'script') {
            return <React.Fragment />;
        }

        const attributes = domNode.attribs || {};
        if (attributes.target === '_blank' && !attributes.rel?.includes('noopener')) {
            attributes.rel = attributes.rel ? attributes.rel.concat(' ', 'noopener') : 'noopener';
            const props = attributesToProps(attributes);
            return <a {...props}>{domToReact(domNode.children)}</a>;
        }
    }
};

type Props = {
    html: string;
    additionalProps: any;
};

export const HtmlParser: React.FC<Props> = ({html, additionalProps}) => {
    const parsedHtml = parse(html, parserOptions);

    if (additionalProps && React.isValidElement(parsedHtml)) {
        return React.cloneElement(parsedHtml, additionalProps);
    }

    return <Fragment>{parsedHtml}</Fragment>;
};
